(function () {
	'use strict';

	angular.module('dcApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('public-root', {
			url: '',
			parent: 'root',
			abstract: true,
			views: {
				'app@': {
					template: '<ui-view/>',
					controller: [
						'$scope',
						'$timeout',
						function ($scope, $timeout) {
							$scope.showSplash = true;

							// Remove the index.html splash (layer 1) — no longer needed
							var htmlSplash = document.getElementById('html-splash');
							if (htmlSplash) {
								htmlSplash.remove();
							}

							// Listen for the Angular Element's dismissed event
							$timeout(function () {
								var el = document.getElementById('angular-splash');
								if (el) {
									el.addEventListener('dismissed', function () {
										$scope.$apply(function () {
											$scope.showSplash = false;
										});
									});
								}
							});
						},
					],
				},
			},
		});

		$stateProvider.state('public', {
			url: '/public/:link',
			parent: 'public-root',
			data: {
				admin: false,
				access: '*',
				title: 'Publication',
			},
			views: {
				'@public-root': {
					templateUrl: './src/components/modules/hd/dashboard/publication.html',
					controller: 'PublicationController',
				},
			},
		});

		$stateProvider.state('data', {
			url: '/data/:rootCode/:dbName/info',
			parent: 'public-root',
			data: {
				admin: false,
				access: '*',
				title: 'DataBlock',
			},
			views: {
				'@public-root': {
					templateUrl: './src/components/modules/datablocks/expose.html',
					controller: 'DbExposeController',
				},
			},
		});
	}
})();
